"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const core_1 = require("@material-ui/core");
const Save_1 = (0, tslib_1.__importDefault)(require("@material-ui/icons/Save"));
const S = (0, tslib_1.__importStar)(require("./styles"));
const molecules_1 = require("../../../molecules");
const RoleCreate = (_a) => {
    var { features, onSubmit } = _a, props = (0, tslib_1.__rest)(_a, ["features", "onSubmit"]);
    const history = (0, react_router_dom_1.useHistory)();
    const [roleName, setRoleName] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        setRoleName(props.roleName);
    }, [props.roleName]);
    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit({
            roleName,
        });
    };
    const hadleCancel = () => {
        history.goBack();
    };
    return ((0, jsx_runtime_1.jsx)(S.Form, Object.assign({ onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsxs)(core_1.Grid, Object.assign({ container: true, spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(molecules_1.RoleForm, Object.assign({}, props), void 0), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(molecules_1.SetPermission, { permissionTitle: "Permissions Admin", features: features.admin }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(molecules_1.SetPermission, { permissionTitle: "Permissions Storefront", features: features.storefront }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ variant: "outlined", type: "button", onClick: hadleCancel, fullWidth: true }, { children: "Cancel" }), void 0) }), void 0), (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ variant: "contained", endIcon: (0, jsx_runtime_1.jsx)(Save_1.default, {}, void 0), type: "submit", fullWidth: true }, { children: "Update" }), void 0) }), void 0)] }), void 0) }), void 0));
};
exports.default = RoleCreate;
